import { LocalStorageConsentStore } from './store.local';
import { CookieConsentStore } from './store.cookie';
export class TagController {
    registry = new Map();
    register(r) {
        this.registry.set(r.id, { ...r, enabled: false });
    }
    enableCategory(category) {
        for (const r of this.registry.values()) {
            if (r.category === category && !r.enabled) {
                r.loader();
                r.enabled = true;
            }
        }
    }
    disableCategory(category) {
        for (const r of this.registry.values()) {
            if (r.category === category) {
                r.enabled = false;
                // Unloading is tag-specific and not attempted here
            }
        }
    }
}
export class ConsentCore {
    version;
    store;
    tags = new TagController();
    gpcActive;
    state;
    listeners = new Set();
    constructor(opts) {
        this.version = opts.version;
        this.store =
            opts.store === 'cookie'
                ? new CookieConsentStore(opts.cookieDomain)
                : new LocalStorageConsentStore();
        const gpc = typeof navigator !== 'undefined' &&
            navigator.globalPrivacyControl === true;
        this.gpcActive = !!gpc;
        const saved = this.store.read();
        let categories;
        if (saved?.version === this.version) {
            categories = saved.categories;
        }
        else {
            const initial = opts.initial ?? {};
            const inOptOutRegion = opts.geofencing?.eeaRequiresOptIn === false;
            // If GPC is active, force non-essential off regardless of region
            if (this.gpcActive) {
                categories = {
                    essential: true,
                    analytics: initial.analytics ?? false,
                    marketing: initial.marketing ?? false,
                    functional: initial.functional ?? false,
                };
            }
            else if (inOptOutRegion) {
                // Opt-out regions default to granted for non-essential unless overridden by initial
                categories = {
                    essential: true,
                    analytics: initial.analytics ?? true,
                    marketing: initial.marketing ?? true,
                    functional: initial.functional ?? true,
                };
            }
            else {
                // Opt-in regions (EEA etc.) default to denied for non-essential unless overridden by initial
                categories = {
                    essential: true,
                    analytics: initial.analytics ?? false,
                    marketing: initial.marketing ?? false,
                    functional: initial.functional ?? false,
                };
            }
        }
        this.state = {
            version: this.version,
            updatedAt: new Date().toISOString(),
            source: saved ? 'import' : 'banner',
            categories,
        };
    }
    getState() {
        return this.state;
    }
    subscribe(cb) {
        this.listeners.add(cb);
        return () => this.listeners.delete(cb);
    }
    notify() {
        for (const cb of this.listeners)
            cb(this.state);
    }
    applyTags(categories) {
        ['analytics', 'marketing', 'functional'].forEach((cat) => {
            if (categories[cat]) {
                this.tags.enableCategory(cat);
            }
            else {
                this.tags.disableCategory(cat);
            }
        });
    }
    setAll(granted) {
        this.set({
            essential: true,
            analytics: granted,
            marketing: granted,
            functional: granted,
        }, 'banner');
    }
    set(partial, source) {
        const categories = 'categories' in partial
            ? {
                ...this.state.categories,
                ...partial.categories,
            }
            : { ...this.state.categories, ...partial };
        this.state = {
            version: this.version,
            updatedAt: new Date().toISOString(),
            source,
            categories,
        };
        this.store.write(this.state);
        this.applyTags(categories);
        this.notify();
    }
    clear() {
        this.store.clear();
    }
    // Re-apply current consent categories to tag registry without mutating state or storage
    apply() {
        this.applyTags(this.state.categories);
    }
}
export function createConsentCore(opts) {
    return new ConsentCore(opts);
}
//# sourceMappingURL=core.js.map